import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { resolveAuthGuardAccess, resolveGuestGuardAccess } from './auth-session.access';

export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return resolveAuthGuardAccess(auth, router);
};

export const guestGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return resolveGuestGuardAccess(auth, router);
};
